// Polish display names for the official menu (source: restaurant's printed menu)
export const CATEGORIES_PL = {
    starters: { title: "Przystawki", desc: "Chrupiące początki z frytownicy i tandoora." },
    "salad-raita": { title: "Sałatki i raita", desc: "Świeże, chłodzące dodatki." },
    soups: { title: "Zupy", desc: "Ciepłe, delikatnie przyprawione." },
    "vegetarian-curry": { title: "Curry wegetariańskie", desc: "Wolno gotowane klasyki indyjskiej kuchni." },
    "chicken-curry": { title: "Curry z kurczakiem", desc: "Od kremowych i łagodnych po odważnie pikantne." },
    "lamb-curry": { title: "Curry z jagnięciny", desc: "Głębokie, wolno duszone smaki." },
    tandoor: { title: "Dania z tandoora", desc: "Pieczone w tradycyjnym glinianym piecu." },
    bread: { title: "Chlebki indyjskie", desc: "Pieczone na zamówienie na glinianych ścianach tandoora." },
    "rice-biryani": { title: "Ryż i biryani", desc: "Pachnący basmati, warstwowy i aromatyczny." },
    "kati-roll": { title: "Kati roll — wege i kurczak", desc: "Uliczne rolki w stylu Kalkuty." },
    fish: { title: "Curry z ryb", desc: "Przygotowania w nadmorskim stylu." },
    "indo-chinese": { title: "Indo-chińskie", desc: "Azjatyckie smaki z woka." },
    drinks: { title: "Napoje", desc: "Lassi, chai i napoje chłodzące." },
    desserts: { title: "Desery", desc: "Łagodne, słodkie zakończenie." },
};

export const DISHES_PL = {
    "Chicken Samosa": { name: "Samosa z kurczakiem" },
    "Aloo Samosa": { name: "Samosa aloo (ziemniaczana)" },
    "Mixed Pakora": { name: "Pakora mieszana" },
    "Paneer Pakora": { name: "Pakora z paneer" },
    "Chicken Pakora": { name: "Pakora z kurczaka" },
    "Prawn Pakora": { name: "Pakora z krewetek" },
    "Mixed Veg Raita": { name: "Raita warzywna" },
    "Green Salad": { name: "Zielona sałatka" },
    "Chicken Tikka Salad": { name: "Sałatka z chicken tikka" },
    "Paneer Salad": { name: "Sałatka z paneer" },
    "Aloo Chana Chat": { name: "Aloo chana chaat" },
    "Samoosa Chat": { name: "Samosa chaat" },
    "Dal Soup": { name: "Zupa dal (soczewicowa)" },
    "Tomato Soup": { name: "Zupa pomidorowa" },
    "Chicken Soup": { name: "Zupa z kurczaka" },
    "Prawn Soup": { name: "Zupa z krewetek" },
    "Cheese Paneer Butter Masala": { name: "Paneer butter masala z serem" },
    "Paneer Tikka Masala": { name: "Paneer tikka masala" },
    "Paneer Kadai": { name: "Paneer kadai" },
    "Paneer Korma": { name: "Paneer korma" },
    "Paneer Lababdar": { name: "Paneer lababdar" },
    "Rajma Masala": { name: "Rajma masala (fasola)" },
    "Dal Tadka": { name: "Dal tadka" },
    "Chana Masala": { name: "Chana masala (ciecierzyca)" },
    "Butter Chicken": { name: "Butter chicken" },
    "Chicken Tikka Masala": { name: "Chicken tikka masala" },
    "Mango Chicken": { name: "Kurczak mango" },
    "Chicken Korma": { name: "Korma z kurczaka" },
    "Chicken Kadai": { name: "Kadai z kurczaka" },
    "Chicken Jalfrezi": { name: "Jalfrezi z kurczaka" },
    "Chicken Palak": { name: "Kurczak palak (szpinak)" },
    "Chicken Madras": { name: "Madras z kurczaka" },
    "Chicken Lababdar": { name: "Lababdar z kurczaka" },
    "Chicken Vindaloo": { name: "Vindaloo z kurczaka" },
    "Lamb Curry": { name: "Curry z jagnięciny" },
    "Lamb Rogan Josh": { name: "Rogan josh z jagnięciny" },
    "Lamb Kadai": { name: "Kadai z jagnięciny" },
    "Lamb Mango": { name: "Jagnięcina mango" },
    "Lamb Korma": { name: "Korma z jagnięciny" },
    "Lamb Palak": { name: "Jagnięcina palak (szpinak)" },
    "Lamb Madras": { name: "Madras z jagnięciny" },
    "Lamb Tikka Masala": { name: "Tikka masala z jagnięciny" },
    "Butter Lamb": { name: "Butter lamb" },
    "Tandoori Chicken": { name: "Kurczak tandoori" },
    "Malai Chicken": { name: "Kurczak malai" },
    "Chicken Tikka": { name: "Chicken tikka" },
    "Prawns Tikka": { name: "Krewetki tikka" },
    Roti: { name: "Roti" },
    "Plain Nan": { name: "Nan naturalny" },
    "Butter Nan": { name: "Nan maślany" },
    "Garlic Nan": { name: "Nan czosnkowy" },
    "Peshawari Nan": { name: "Nan peshawari" },
    "Cheese Nan": { name: "Nan z serem" },
    "Aloo Parota": { name: "Paratha aloo (ziemniaczana)" },
    "Lacha Parata": { name: "Paratha lacha (warstwowa)" },
    "Amritsari Kulcha": { name: "Kulcha amritsari" },
    "Plain Basmati Rice": { name: "Ryż basmati naturalny" },
    "Jeera Rice": { name: "Ryż jeera (kumin)" },
    "Veg Palou": { name: "Pulao warzywny" },
    "Chicken Biryani": { name: "Biryani z kurczakiem" },
    "Lamb Biryani": { name: "Biryani z jagnięciny" },
    "Prawns Biryani": { name: "Biryani z krewetkami" },
    "Vegetable Biryani": { name: "Biryani warzywne" },
    "Lemon Rice": { name: "Ryż cytrynowy" },
    "Paneer Kati Roll": { name: "Kati roll z paneer" },
    "Chicken Kati Roll": { name: "Kati roll z kurczakiem" },
    "Mutton Kati Roll": { name: "Kati roll z baraniną" },
    "Fish Madras": { name: "Ryba madras" },
    "Fish Vindaloo": { name: "Ryba vindaloo" },
    "Chicken Chilli": { name: "Kurczak chilli" },
    "Chicken 65": { name: "Chicken 65" },
    "Paneer Chilli": { name: "Paneer chilli" },
    "Vegetable Fried Rice": { name: "Ryż smażony warzywny" },
    "Chicken Fried Rice": { name: "Ryż smażony z kurczakiem" },
    "Egg Fried Rice": { name: "Ryż smażony z jajkiem" },
    "Chicken Noodles": { name: "Makaron z kurczakiem" },
    "Prawn Noodles": { name: "Makaron z krewetkami" },
    "Vegetable Noodles": { name: "Makaron warzywny" },
    "Mango Lassi": { name: "Lassi mango" },
    "Jeera Salt Lassi": { name: "Lassi słone z kuminem" },
    "Sweet Lassi": { name: "Lassi słodkie" },
    Pepsi: { name: "Pepsi" },
    Fanta: { name: "Fanta" },
    "Lipton Peach": { name: "Lipton brzoskwinia" },
    "Water Naturalny": { name: "Woda naturalna" },
    "Indian Masala Tea": { name: "Indyjska herbata masala" },
    "Black Coffee": { name: "Kawa czarna" },
    "Coconut Lassi": { name: "Lassi kokosowe" },
    "Gulab Jamun": { name: "Gulab jamun" },
    "Rice Kheer": { name: "Kheer (budyń ryżowy)" },
    "Carrot Halwa": { name: "Halwa marchewkowa" },
};

